import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index.js'
const index = () => import('@/pages/index')
import noAuth from '@/pages/404'
import chargeOrderRouter from './chargeOrder'
import repairIndex from './repairIndex'
import thirdRepair from './thirdRepair'
import indexSearch from './indexSearch'
import Tbox from './Tbox'
import safety from './safety'
import bindGps from './bindGps'
import dangerHandle from './dangerHandle'
import checkDanger from './checkDanger'
import collectingMoney from './collectingMoney'
import maintain from './maintain'
import smartDamage from './smartDamage'
import repairDate from './repairDate'
import commonPage from './commonPage'
import fileLend from './fileLend'
import carBreakRule from './carBreakRule'
import carYearCheck from './carYearCheck'
import cardYearCheck from './cardYearCheck'
import carPassCard from './carPassCard'
import driveCardHandle from './driveCardHandle'
import repairPlan from './repairPlan'
import vehicleAdjustment from './vehicleAdjustment'
import vehicleAttribute from './vehicleAttribute'
import windFireWheel from './windFireWheel'
import pickUpTyre from './pickUpTyre'
import recordCar from './recordCar'
import checkCar from './checkCar'
import replaceCar from './replaceCar'
import deliveryCar from './deliveryCar'
import returnCar from './returnCar'
import stationMissionCenter from './stationMissionCenter'
import demo from './demo'
import Demo from '@/m-common/demo/router'
import lockCar from './lockCar'
import lockCarNew from './lockCarNew'
import collectionOfVehicles from './collectionOfVehicles'
import carRegistration from './carRegistration'
import collectionCarTask from './collectionCarTask'
import motorCarMesssage from './motorCarMesssage'
Vue.use(VueRouter)
const routerList = {
  routes: [
    ...chargeOrderRouter,
    ...bindGps,
    ...repairIndex,
    ...thirdRepair,
    ...Tbox,
    ...indexSearch,
    ...dangerHandle,
    ...safety,
    ...checkDanger,
    ...collectingMoney,
    ...maintain,
    ...smartDamage,
    ...repairDate,
    ...commonPage,
    ...fileLend,
    ...carBreakRule,
    ...carYearCheck,
    ...cardYearCheck,
    ...carPassCard,
    ...driveCardHandle,
    ...repairPlan,
    ...vehicleAdjustment,
    ...vehicleAttribute,
    ...windFireWheel,
    ...pickUpTyre,
    ...recordCar,
    ...checkCar,
    ...replaceCar,
    ...deliveryCar,
    ...returnCar,
    ...stationMissionCenter,
    ...demo,
    ...Demo,
    ...lockCar,
    ...lockCarNew,
    ...carRegistration,
    ...collectionOfVehicles,
    ...collectionCarTask,
    ...motorCarMesssage,
    {
      path: '/',
      name: 'index',
      component: index,
      meta: {
        storeKey: 'trs.getting.index'// 储存的key 等于undefined则不验证
      }
    },
    {
      path: '/404',
      name: '404',
      component: noAuth,
      meta: {}
    }

  ]
}

let routerTrigger = false
class Router extends VueRouter {
  push(location, onComplete, onAbort) {
    console.log(1)
    routerTrigger = true
    store.commit('history/PUSH_ROUTE', super.resolve(location).resolved)
    super.push(location, onComplete, onAbort)
  }
  replace(location, onComplete, onAbort) {
    routerTrigger = true
    store.commit('history/REPLACE_ROUTE', super.resolve(location).resolved)
    super.replace(location, onComplete, onAbort)
  }
  go(n) {
    if (n !== 0) {
      routerTrigger = true
      const hrefArr = location.hash.split('?')[0]
      const path = hrefArr.replace(/#(\/.*)/, '$1')
      store.commit('history/POP_ROUTE', { count: n, path })
      super.go(n)
    } else {
      window.location.reload()
    }
  }
}
const router = new Router(routerList)
router.afterEach((to, from) => {
  if (to.matched.length > 0 && store.state.history.records.length === 0) {
    store.commit('history/PUSH_ROUTE', to)
  } else if (!routerTrigger && to.fullPath) {
    store.commit('history/POP_ROUTE', {
      path: to.fullPath
    })
  }
  routerTrigger = false
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js